import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Segmented } from 'antd';
import { useThemeMode, type ThemeMode } from '@goelectric/ui-components';

const THEME_OPTIONS = [
  { value: 'light', icon: <SunOutlined />, label: 'Claro' },
  { value: 'dark', icon: <MoonOutlined />, label: 'Oscuro' },
  { value: 'system', icon: <DesktopOutlined />, label: 'Sistema' },
];

/** Toggle de tema Claro / Oscuro / Sistema (persistido por usuario). */
export function ThemeToggle() {
  const { mode, setMode } = useThemeMode();

  return (
    <Segmented
      aria-label="Tema de la interfaz"
      value={mode}
      options={THEME_OPTIONS}
      onChange={(value) => setMode(value as ThemeMode)}
    />
  );
}
